import { render, staticRenderFns } from "./ReactionTestsNewQuestion.vue?vue&type=template&id=40c95e82&"
import script from "./ReactionTestsNewQuestion.vue?vue&type=script&lang=js&"
export * from "./ReactionTestsNewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ReactionTestsNewQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReactionTestsNewQuestion.vue"
export default component.exports